<template>
    <el-dialog title="积分明细" :visible.sync="showModal" width="80%" :close-on-click-modal="false"
        :destroy-on-close="true">
        <div class="filter-container">
            <div class="filter-box">
                <el-date-picker v-model="dateList" size="medium" style="min-width:400px;margin-right:10px;" type="daterange"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                    clearable />
                <el-select v-model="listQuery.type" size="medium" placeholder="请选择类型" clearable style="margin-right:10px;">
                    <el-option label="收入" :value="1" />
                    <el-option label="支出" :value="2" />
                </el-select>
                <el-button type="primary" size="medium" @click="handleSearch">搜索</el-button>                          
            </div>
            <el-button type="warning" :loading="tableLoading" icon="el-icon-upload2" @click="exportExcel">导出Excel</el-button>
        </div>
        <el-table v-loading="tableLoading" :data="tableData" element-loading-text="Loading" size="small" border fit>
            <el-table-column type="index" align="center" label="序号" min-width="20" />
            <el-table-column prop="type" label="类型" min-width="38" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.type === 1">收入</span>
                    <span v-else-if="scope.row.type === 2">支出</span>
                    <span v-else>其它</span>
                </template>
            </el-table-column>
            <el-table-column prop="details" label="说明" min-width="50" align="center" />
            <el-table-column prop="integral" label="积分" min-width="50" align="center" />
            <el-table-column prop="surplus_integral" label="操作后积分" min-width="50" align="center" />
            <el-table-column prop="created_at" label="操作时间" min-width="50" align="center" />
        </el-table>

        <div class="pagination-container">
            <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
    </el-dialog>
</template>

<script>
import { user } from "@/api/userManagement"
import * as XLSX from "xlsx"

export default {
    data: () => ({
        filterParams: {},
        tableLoading: false,
        tableData: [],
        listQuery: {
            page: 1,
            limit: 10,
            start_at: '',
            end_at: '',
            type: ''
        },
        total: null,
        dateList: []
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 用户ID
        userID: null | String,
        // 用户昵称
        userName: null | String,
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        async getList() {
            this.tableLoading = true
            console.log(this.listQuery)
            const { data } = await user.pointLog({ user_id: this.userID, ...this.listQuery })
            this.tableData = data.data
            this.total = data.total
            this.tableLoading = false
        },
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        handleSearch() {
            this.listQuery.page = 1
            this.getList()
        },
        // 导出Excel
        async exportExcel() {
            console.log('exportExcel')
            // +++修改excel-用户列表-积分明细-附件 8.1---ok
            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await user.pointLog({ user_id: this.userID,...this.listQuery, page: 1, limit: 999999 })
                console.log(reqData);

                var wb = XLSX.utils.book_new();
                

                var excelData = [
                    ['序号'	,'明细类型','项目','积分','积分余额','操作时间'],
                    ...reqData.map((item, index) => [
                        index + 1,
                        item.type === 1 ? '新增' : item.type === 2 ? '扣除': '',
                        item.details,
                        item.integral,
                        item.surplus_integral,
                        item.created_at
                    ])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "积分明细");
                XLSX.writeFile(wb, `用户管理-积分明细-${this.userName}.xlsx`);

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
    },
    watch: {
        dateList: {
            handler(nval) {
                if (nval) {
                    this.listQuery.start_at = nval[0]
                    this.listQuery.end_at = `${nval[1]} 23:59`
                } else {
                    this.listQuery.start_at = this.listQuery.end_at = ''
                }
            },
            deep: true
        }
    },
    created() {
        console.log(this.userID);
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
.filter {
    display: flex;
    align-items: center;
    margin: 0 -6px;

    .filter-item {
        margin: 0 6px;
    }
}

.table {
    margin-top: 30px;
}

.filter-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    
    .filter-box{
        display: flex;
        flex-wrap: wrap;
        &>*{
            margin: 0 10px 10px 0;
        }
    }

}
</style>